import { createFileRoute, Link } from "@tanstack/react-router";
import { ServiceAgreementBody, LEGAL_VERSIONS } from "@/lib/legal/documents";

export const Route = createFileRoute("/legal/service-agreement")({
  head: () => ({
    meta: [
      { title: "Service Agreement — Truck Company Center" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ServiceAgreementPage,
});

function ServiceAgreementPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
      <Link to="/" className="text-xs text-muted-foreground hover:text-foreground">← Inicio</Link>
      <h1 className="mt-3 font-display text-3xl font-semibold text-foreground md:text-4xl">
        Service Agreement
      </h1>
      <p className="mt-2 text-xs uppercase tracking-[0.18em] text-label-accent">
        Version {LEGAL_VERSIONS.service_agreement}
      </p>
      <div className="mt-6"><ServiceAgreementBody /></div>
    </div>
  );
}
